// @flow
import * as constants from './constants';

import { call, cancel, fork, put, select, take, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import type { DisableHolidayModeAction, SetHolidayModeAction } from './types';
import {
    disableHolidayMode as disableHolidayModeApi,
    getHolidayMode as getHolidayModeApi,
    setHolidayMode as setHolidayModeApi
} from '~/core/api/holiday-mode';
import { initializeState, initiateHolidayMode } from './actions';

import { capabilities } from '~/core/constants/devices';
import { dashboard } from '~/core/constants/routes';
import { doesAnyProductHaveCapability } from '~/core/state/products/selectors';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import { navigate } from '~/core/state/navigate';
import { noop } from 'lodash/fp';

const checkHolidayModeDelay = 120000;

export function* setHolidayModeSaga({
    payload: { start, end, temperature }
}: SetHolidayModeAction): Generator<noop | Effect, *, *> {
    const [, err] = yield call(handleApi(setHolidayModeApi), start, end, temperature);
    yield put(initiateHolidayMode(err));
}

export function* watchSetHolidayModeSaga(): Generator<Effect, *, *> {
    yield takeLatest(constants.SET_HOLIDAY_MODE, handleSaga(setHolidayModeSaga));
}

function* holidayModeDaemonSaga(): Generator<Effect, *, *> {
    while (true) {
        yield call(delay, checkHolidayModeDelay);
        yield call(getHolidayModeDataSaga);
    }
}

export function* watchHolidayModeDaemonSaga(): Generator<Effect, *, *> {
    while (true) {
        yield take(constants.INITIATE_HOLIDAYMODE);
        const deamon = yield fork(holidayModeDaemonSaga);
        yield take(constants.EXIT_HOLIDAY_MODE_SCREEN);
        yield cancel(deamon);
    }
}

export function* getHolidayModeDataSaga(): Generator<noop | Effect, *, *> {
    let payload = {};

    // $FlowFixMe
    const anySuitableProducts = select(doesAnyProductHaveCapability, {
        capability: capabilities.HOLIDAY_MODE
    });

    if (anySuitableProducts) {
        const [response, e] = yield call(handleApi(getHolidayModeApi));
        payload = e || response;
    }

    yield put(initializeState(payload));
}

export function* watchGetHolidayModeDataSaga(): Generator<Effect, *, *> {
    yield takeLatest(constants.INITIATE_HOLIDAYMODE, handleSaga(getHolidayModeDataSaga));
}

export function* disableHolidayModeSaga({
    payload: remain = false
}: DisableHolidayModeAction): Generator<Effect | noop, *, *> {
    if (!remain) {
        yield put(navigate(dashboard));
    }

    yield call(handleApi(disableHolidayModeApi));
}

export function* watchDisableHolidayModeSaga(): Generator<Effect, *, *> {
    yield takeLatest(constants.DISABLE_HOLIDAY_MODE, handleSaga(disableHolidayModeSaga));
}

export default [
    watchHolidayModeDaemonSaga,
    watchDisableHolidayModeSaga,
    watchGetHolidayModeDataSaga,
    watchSetHolidayModeSaga
];



// WEBPACK FOOTER //
// ./src/core/state/holiday-mode/sagas.js